module.exports = __webpack_public_path__ + "static/el-obrero-internacional-6-3786f4a5e00dbc22207cf562008a4e69.png";